import React from 'react';

export default function FormattedSpeed({ mbps }: { mbps: number }) {
  const isBinary = mbps % 1024 === 0;
  const divisor = isBinary ? 1024 : 1000;

  let value = mbps;
  let unit = 'Mbps';

  if (mbps >= divisor) {
    value = Math.round((mbps / divisor) * 100) / 100;
    unit = 'Gbps';
  }

  return (
    <>
      {value} {unit}
    </>
  );
}
